// Recomendaciones técnicas (Módulo 6): catálogo editable en Configuración. Se guarda una copia en el dispositivo
// para que la planilla funcione sin conexión; si nunca se descargó, se usa la lista base.
import { getRecomendacionesTecnicas } from '../services/api';

const CLAVE = 'freshen_recos_catalogo';

const BASE = [
  ['Almacenamiento y orden adecuados.', false], ['Limpieza e higiene general (superficies, sin grasa, bajo estanterías, jardines).', false],
  ['Burletes en puertas y accesos.', false], ['Puertas y accesos cerrados correctamente.', false], ['Mallas de protección en ventanas.', false],
  ['Desagües cerrados y sin aberturas en bordes.', false], ['Desagües con mallas de protección.', false], ['Basureros con tapa.', false],
  ['Huecos o perforaciones en estructuras.', true], ['Grietas o fisuras en estructuras.', true],
  ['Techos sin aberturas o puntos de ingreso.', false], ['Poda y mantenimiento de árboles y/o vegetación.', false],
  ['Riesgos potenciales de ingreso de plagas (puntos vulnerables).', true], ['Agua estancada.', true], ['Otros', false],
];
export const RECOS_BASE = BASE.map(([label, neg], i) => ({
  id: `f${i}`, label, negativoEnSi: neg, esOtros: label === 'Otros', esRiesgosPotenciales: label.startsWith('Riesgos potenciales'),
}));

export const catalogoRecos = () => {
  try {
    const c = JSON.parse(localStorage.getItem(CLAVE) || 'null');
    if (Array.isArray(c) && c.length) return c;
  } catch { /* copia dañada: se usa la base */ }
  return RECOS_BASE;
};

export const guardarCatalogoRecos = (items) => { try { localStorage.setItem(CLAVE, JSON.stringify(items)); } catch { /* sin espacio */ } };

export const cargarCatalogoRecos = async () => {
  try {
    const items = (await getRecomendacionesTecnicas()).data?.items;
    if (Array.isArray(items) && items.length) { guardarCatalogoRecos(items); return items; }
  } catch { /* sin conexión: queda la copia del dispositivo */ }
  return catalogoRecos();
};

export const itemM6 = (f) => ({
  _key: f.id, factor: f.label, negativoEnSi: !!f.negativoEnSi, esOtros: !!f.esOtros, esRiesgosPotenciales: !!f.esRiesgosPotenciales,
  estado: null, ubicaciones: [{ _key: 'u0', texto: '' }], evidencia: null, evidencias: [], otrosItems: [],
});

export const itemsM6 = (cat = catalogoRecos()) => cat.map(itemM6);

// Borrador guardado → lista vigente: cada recomendación conserva lo respondido (por clave o texto); las quitadas del catálogo se descartan
export const normClavesM6 = (lista, cat = catalogoRecos()) => {
  if (!Array.isArray(lista)) return lista;
  return cat.map((f) => {
    const previo = lista.find((it) => it?._key === f.id) || lista.find((it) => it?.factor === f.label);
    return previo ? { ...itemM6(f), ...previo, ...{ _key: f.id, factor: f.label, negativoEnSi: !!f.negativoEnSi, esOtros: !!f.esOtros, esRiesgosPotenciales: !!f.esRiesgosPotenciales } } : itemM6(f);
  });
};
